import React, { useState, useEffect } from "react";
import ChatTabs from "./ChatTabs";
import ChatSearch from "./ChatSearch";
import ChatBoxMain from "./ChatBoxMain";
import Loader from "../../shared/loader";
import { GetAllConversations } from "../../../services/admin/chat";

const ChatMain = () => {
  const [loading, setLoading] = useState(false);
  const [AllData, setAllData] = useState([]);
  const [ActiveType, setActiveType] = useState("CUSTOMERS");

  useEffect(() => {
    handleFetchAllConversations();
  }, [ActiveType]);
  const handleFetchAllConversations = async () => {
    await GetAllConversations(setLoading, setAllData, ActiveType);
  };

  return (
    <>
      {loading && <Loader />}
      <ChatTabs setActiveType={setActiveType} />
      {!loading && (
        <>
          <ChatSearch
            AllData={AllData}
            setAllData={setAllData}
            ActiveType={ActiveType}
          />
          <ChatBoxMain AllData={AllData} />
        </>
      )}
    </>
  );
};

export default ChatMain;
